// Cliente das rotas do ALFREDO ROTA no alfredo-central-backend.
//
// O Central é onde o DONO do restaurante decide o que o cliente final vê
// enquanto o pedido está a caminho — e é o coração do card #93. Quem CONSOME
// essa decisão é o app do entregador (`rota.alfredo.food`) e a página de
// acompanhamento do alfredo-pedidos; quem a ESCREVE é daqui.
//
// Ele é um service separado do `site.service.ts` de propósito: entrega é outro
// domínio (outro schema, outro repositório, outro app), e juntar os dois faria
// a tela de Unidades importar um cliente que sabe de tudo.
import api from "./api.service";

export type ModoDeCompartilhamento = "PREVISAO" | "ROTA_REAL";

export interface ConfigDeEntrega {
  subsidiaryUuid: string;
  modoDeCompartilhamento: ModoDeCompartilhamento;
  minutosDePreparo: number;
  minutosPorEntrega: number;
  folgaDaFaixaMinutos: number;
  mostrarNomeDoEntregador: boolean;
  /** Falso quando a unidade ainda não tem linha e está lendo o padrão. */
  configurada: boolean;
}

export interface RespostaDaConfig {
  config: ConfigDeEntrega;
  /**
   * QUEM DECIDE O QUE ESTÁ DISPONÍVEL É O SERVIDOR, e ele diz na resposta.
   *
   * Uma lista chumbada aqui obrigaria alguém a lembrar de mexer nos dois lados
   * no dia em que o rastreamento entrar no ar. Assim o rádio de "rota real"
   * deixa de ser `disabled` no MESMO deploy em que o backend passa a aceitá-lo.
   */
  modosDisponiveis: ModoDeCompartilhamento[];
  motivoRotaRealIndisponivel: string | null;
  aviso?: string | null;
}

export interface EntregadorDaUnidade {
  entregadorId: string;
  nome: string;
  telefone: string;
  ativo: boolean;
  precisaTrocarSenha: boolean;
  ultimoLogin: string | null;
  vinculoId: string;
  aotUserUuid: string | null;
}

class RotaClass {
  async buscarConfig(subsidiaryUuid: string): Promise<RespostaDaConfig> {
    const resposta = await api.get(`/rota/unidades/${subsidiaryUuid}/config`);
    return resposta.data;
  }

  async salvarConfig(
    subsidiaryUuid: string,
    config: Partial<ConfigDeEntrega>
  ): Promise<RespostaDaConfig> {
    const resposta = await api.put(`/rota/unidades/${subsidiaryUuid}/config`, config);
    return resposta.data;
  }

  async listarEntregadores(subsidiaryUuid: string): Promise<{ entregadores: EntregadorDaUnidade[] }> {
    const resposta = await api.get(`/rota/unidades/${subsidiaryUuid}/entregadores`);
    return resposta.data;
  }

  /**
   * `senhaInicial` vem NESTA resposta e em nenhuma outra: o banco só guarda o
   * hash. Quem chama tem de mostrá-la ao dono na hora — não há como relê-la.
   */
  async criarEntregador(
    subsidiaryUuid: string,
    dados: { nome: string; telefone: string; aotUserUuid?: string | null }
  ): Promise<{ entregador: EntregadorDaUnidade; senhaInicial: string | null }> {
    const resposta = await api.post(`/rota/unidades/${subsidiaryUuid}/entregadores`, dados);
    return resposta.data;
  }

  async atualizarEntregador(
    entregadorId: string,
    dados: {
      nome?: string;
      ativo?: boolean;
      aotUserUuid?: string | null;
      subsidiaryUuid?: string;
      gerarSenha?: boolean;
    }
  ): Promise<{ ok: true; senhaInicial: string | null }> {
    const resposta = await api.patch(`/rota/entregadores/${entregadorId}`, dados);
    return resposta.data;
  }
}

export const rotaService = new RotaClass();
